import moment from "moment";
import "moment/locale/tr";

// Locale dosyası yüklenince global dil değişir; diğer sayfalar etkilenmesin diye geri alınır
moment.locale("en");

export const BRAND = "#ae094d";

export const STATUS_LABELS = { draft: "Taslak", approved: "Onaylandı", paid: "Ödendi", mixed: "Karma" };
export const STATUS_COLORS = { draft: "default", approved: "blue", paid: "green", mixed: "orange" };

export const PENALTY_REASONS = {
  miss: "Öğretmenin kaçırdığı ders",
  late: "Geç kalma",
  quality: "Kalite ihlali",
  other: "Diğer",
};
export const PENALTY_SOURCES = {
  teacher: "Öğretmen kaynaklı",
  student: "Öğrenci kaynaklı",
  system: "Sistem kaynaklı",
  review: "İncelemede",
};
export const EVALUATION_LABELS = { 1: "Yetersiz", 2: "Normal", 3: "Harika" };
export const EVALUATION_STARS = { 1: 1, 2: 3, 3: 5 };

export const BAND_COLORS = {
  "Çok iyi": "green",
  "İyi": "cyan",
  "Gelişim gerekli": "gold",
  "Riskli": "orange",
  "Kritik": "red",
};

const num = new Intl.NumberFormat("tr-TR");
const dec = new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtInt = (v) => num.format(Math.round(Number(v) || 0));
export const fmtDec = (v) => dec.format(Number(v) || 0);
export const fmtUsd = (v) => (v === null || v === undefined ? "—" : `$${dec.format(v)}`);
export const fmtPeriod = (period) => moment(period + "-01").locale("tr").format("MMMM YYYY");
export const fmtDay = (day) => moment(day).format("DD.MM.YYYY");

export const teacherName = (t) => `${t.first_name || ""} ${t.last_name || ""}`.trim();

/** Gün bazlı ücret özeti: "180 / 40" ya da farklı ücretli günler varsa "180 / 40 (5 gün) · 200 / 40 (2 gün)" */
export const rateLabel = (rates) =>
  (rates || []).length === 1
    ? `${fmtDec(rates[0].hourly)} / ${fmtDec(rates[0].idle)}`
    : (rates || []).map((r) => `${fmtDec(r.hourly)} / ${fmtDec(r.idle)} (${r.days} gün)`).join(" · ");

/** Yorumu yapan öğrenci: "Ad Soyad · email" */
export const reviewerLabel = (r) =>
  [`${r.student_first_name || ""} ${r.student_last_name || ""}`.trim() || "-", r.student_email].filter(Boolean).join(" · ");

// Eğitmen hesap durumu: users.status 1 = aktif, diğerleri pasif
export const isActiveTeacher = (t) => Number(t.user_status) === 1;
export const ACTIVE_OPTIONS = [
  { value: "all", label: "Aktif / Pasif (tümü)" },
  { value: "active", label: "Aktif" },
  { value: "passive", label: "Pasif" },
];
export const matchesActive = (t, filter) =>
  filter === "all" || (filter === "active" ? isActiveTeacher(t) : !isActiveTeacher(t));

/** Seçili aylardaki bordro durumlarının özeti; aylar farklıysa "Karma" */
export const statusSummary = (monthly) => {
  const set = [...new Set((monthly || []).map((m) => m.status))];
  if (!set.length) return "draft";
  return set.length === 1 ? set[0] : "mixed";
};

export const lastDays = (n) =>
  Array.from({ length: n }, (_, i) => moment().subtract(n - 1 - i, "days").format("YYYY-MM-DD"));

// Seçili günler bu tarayıcıda hatırlanır (yalnızca kolaylık; veri API'den gelir)
const STORAGE_KEY = "payroll.selectedDays";
export const loadSelectedDays = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (Array.isArray(saved) && saved.length) return saved;
  } catch (e) {}
  return lastDays(7);
};
export const saveSelectedDays = (days) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(days));
  } catch (e) {}
};

/** Seçili günleri kısa metin olarak özetler */
export const selectionSummary = (days) => {
  if (!days.length) return "Gün seçilmedi";
  if (days.length === 1) return fmtDay(days[0]);
  return `${days.length} gün · ${fmtDay(days[0])} – ${fmtDay(days[days.length - 1])}`;
};

export const downloadCSV = (filename, header, rows) => {
  const esc = (v) => {
    const s = v === null || v === undefined ? "" : String(v);
    return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [header, ...rows].map((r) => r.map(esc).join(";")).join("\n");
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const apiError = (err, fallback = "İşlem başarısız oldu.") => err?.response?.data?.message || fallback;
